//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { workOrderDeleteLocation, reset } from "./redux/slice";

const DeleteLocation = ({ refresh, single }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, location, locationList } = useSelector((state) => state.workOrdersDeleteLocationRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteLocations_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = location
                ? messages['manage_deleteLocation_successMessage']
                : messages['manage_deleteLocations_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh && refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={location ? single ? `${messages['manage_deleteLocation_title']} ${location?.name ? ` "${location?.name}"` : ''}` : messages['manage_deleteLocation_title'] : messages['manage_deleteLocations_title']}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => {
                            if (location) {
                                dispatch(workOrderDeleteLocation({ ids: [location?.id] }));
                            }
                            if (locationList?.length) {
                                let ids = locationList.map((item) => item?.id)
                                dispatch(workOrderDeleteLocation({ ids: ids }));
                            }
                        }}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{location ? messages['manage_deleteLocation_description'] : messages['manage_deleteLocations_description']}</p>
                {
                    !single && (
                        <ul>
                            {location ? (
                                <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                    {location?.name}
                                </li>
                            ) : (
                                locationList?.map((crew, index) => (
                                    <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                        {crew.name}
                                    </li>
                                ))
                            )}
                        </ul>
                    )
                }
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteLocation;